import React, { FC } from 'react';
import styles from './LoaderStyles.module.scss';

const Loader: FC = () => {
  return (
    <div className={styles.lds_spinner}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default Loader;
